<template>
  <div id="app">
    <div
      v-if="user"
      class="wrapper">
      <!--<Sidebar v-if="user"/>-->
      <div class="sidenav">
        <router-link
          to="/Client"
        >
          <p style="margin-bottom:0px">客戶管理</p>
        </router-link>
        <router-link
          to="/Project"
        >
          <p style="margin-bottom:0px">項目管理</p>
        </router-link>
        <router-link
          to="/Product"
        >
          <p style="margin-bottom:0px">產品管理</p>
        </router-link>
        <!--<router-link
          to="/ProductionProcedure"
        >
          <p style="margin-bottom:0px">生產程序管理</p>
        </router-link>-->
        <b-button
          variant="none"
          style="box-shadow:none;"
          class="dropdown-btn"
          @click="open">框架
          <i
            class="fa fa-caret-down"
            @click="open"/>
        </b-button>
        <div
          v-show="dropdownState"
          class="dropdown-container">
          <router-link
            to="/Frame"
          >
            <p style="margin-bottom:0px">框架管理</p>
          </router-link>
          <router-link
            to="/FrameType"
          >
            <p style="margin-bottom:0px">框架類型</p>
          </router-link>
        </div>
        <!--<router-link
          to="/PoHWorkDontTouch"
        >
          <p style="margin-bottom:0px">PoH Work Dont Touch</p>
        </router-link>-->
      </div>
      <div class="main">
        <Header v-if="user"/>
        <loading
          :active.sync="$wait.any"
          :can-cancel="false"
          :is-full-page="true"
        />
        <router-view/>
      </div>
    </div>
    <div
      v-if="!user">
      <router-view/>
    </div>
  </div>
</template>

<script>
import Header from '@/components/organisms/OrHeader'
import Sidebar from '@/components/organisms/OrSidebar'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  name: 'App',
  components: {
    Header,
    Sidebar,
    Loading
  },
  data: () => {
    return {
      openContainer: false
    }
  },
  computed: {
    user () {
      if (this.$store.state.Auth.user && localStorage.getItem('token')) return true
      return false
    },
    dropdownState () {
      return this.openContainer
    }
  },
  watch: {
    $route (to, from) {
      this.$store.dispatch('Auth/initUser')
        .then(() => {
          if (this.$store.state.Auth.user === null) {
            this.$router.push('/Login')
          }
        })
    }
  },
  beforeCreate () {
    window.wait = this.$wait
    window.toasted = this.$toasted
    this.$store.dispatch('Auth/initUser')
      .then(() => {
        if (this.$store.state.Auth.user === null) {
          this.$router.push('/Login')
        }
      })
  },
  methods: {
    open () {
      /* var dropdown = document.getElementsByClassName('dropdown-btn')
      var i
      for (i = 0; i < dropdown.length; i++) {
        dropdown[i].addEventListener('click', function () {
          this.classList.toggle('active')
          var dropdownContent = this.nextElementSibling
          if (dropdownContent.style.display === 'block') {
            dropdownContent.style.display = 'none'
          } else {
            dropdownContent.style.display = 'block'
          }
        })
      } */
      if (this.openContainer === true) {
        this.openContainer = false
      } else {
        this.openContainer = true
      }
    }
  }
}
</script>
<style scoped>
.sidenav {
  height: 100%; /* Full-height: remove this if you want "auto" height */
  width: 160px; /* Set the width of the sidebar */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  z-index: 1; /* Stay on top */
  top: 0; /* Stay at the top */
  left: 0;
  background-color: #696969; /* Black */
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 20px;
}

/* The navigation menu links */
.sidenav a, .dropdown-btn {
  padding: 6px 8px 6px 16px;
  text-decoration: none;
  font-size: 20px;
  color: #c5bfbf;
  display: block;
  background-color: #696969;
  width: 100%;
  text-align: left;
  cursor: pointer;
  outline: none;
  border: none;
  background: none;

}

/* When you mouse over the navigation links, change their color */
.sidenav a:hover, .dropdown-btn:hover {
  color: #f1f1f1;
  border:none;
}

/* Style page content */
.main {
  margin-left: 160px; /* Same as the width of the sidebar */
  padding: 0px 10px;
}
.dropdown-container {
  border:none;
  background-color: #696969;
  padding-left: 8px;
}

/* Optional: Style the caret down icon */
.fa-caret-down {
  float: right;
  padding-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue